export default class saleInfo {
  orderId = null
  saleStdDetails = []
  saleOptDetails = []
}
